export default "__VITE_ASSET__BwOIF0T4__"